import { Collapse, Row, Col, notification } from "antd";
import { useEffect, useState } from "react";
import { listOfProgramApi } from "../../../config/Api";
import { DASHBOARD } from "../../../config/constant";
import { setHeaderName } from "../../../services/SetHeaderName";
import { AddNutritionistProgram } from "./AddNutritionistProgram";
import { AddPatient } from "./AddPatient";
import { Plan } from "./Plan";
import { useLocation } from 'react-router-dom';
import "./style/NutritionistDashboard.scss";

export const NutritionistDashboard = () => {
    const { Panel } = Collapse;
    const location = useLocation();

    const [userRole, setUserRole] = useState('')
    const [programUpdate, setProgramUpdate] = useState(false)

    useEffect(() => {
        setHeaderName(DASHBOARD)
        let userData = JSON.parse(localStorage.getItem('user'))
        setUserRole(userData?.user?.role)
        // setUserRole(userData?.user?.role)
        if (location.pathname == '/Dashboard') {
            setHeaderName("Dashboard")
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (location.pathname == '/Dashboard') {
                setHeaderName("Dashboard")
            }
        }, 2000)
    }, []);

    return (
        <div className="NutritionistDashboard">
            {/* Nutritionist  dashboard */}
            {userRole !== "Admin" &&
                <>
                    <Collapse
                        expandIconPosition="end"
                        //   key={index}
                        className="mt-1"
                    >
                        <Panel header="Plan" key="1">
                            <Plan />
                        </Panel>
                    </Collapse>
                    {/* <Collapse
                        expandIconPosition="end"
                    >
                        <Panel header="Create Nutritionist Program " key="2">
                            <AddNutritionistProgram programUpdate={programUpdate} setProgramUpdate={setProgramUpdate} />
                        </Panel>
                    </Collapse> */}
                    <Collapse
                        expandIconPosition="end"
                    >
                        <Panel header="Add Patient " key="3">
                            <AddPatient programUpdate={programUpdate} />
                        </Panel>
                    </Collapse>
                </>
            }
        </div>
    )
}